import _ from "underscore";
import Backbone from "backbone";

export default _.extend({}, Backbone.Events, {
    SAVED: "SAVED",
});
